import type { ObraConfig } from '@services/db.js'

export type EditForm = Omit<ObraConfig, 'id' | 'criadoEm' | 'atualizadoEm'>

export const TIPO_CONTRATACAO = [
  { value: 'empreitada-total', label: 'Empreitada Total' },
  { value: 'empreitada-parcial', label: 'Empreitada Parcial' },
  { value: 'administracao', label: 'Por Administração' },
  { value: 'ainda-nao-sei', label: 'Ainda não sei' },
] as const

export function configToForm(c: ObraConfig): EditForm {
  return {
    nome: c.nome,
    dataInicio: c.dataInicio,
    areaTotal: c.areaTotal,
    padraoConstrucao: c.padraoConstrucao,
    regiao: c.regiao,
    orcamentoTotal: c.orcamentoTotal,
    faseAtual: c.faseAtual,
    tipoContratacao: c.tipoContratacao,
  }
}
